'use strict';
/**
 * Components that are core to the myStrength app. These are things on which almost all our other code will depend.
 */

angular.module('msCore', ['templates', 'translations', 'ui.router', 'ngCookies', 'msUtility', 'ngStorage', 'ngMaterial', 'ngAria']).config(['$stateProvider', '$httpProvider', '$urlRouterProvider', '$locationProvider', '$compileProvider', '$qProvider', '$mdThemingProvider', function ($stateProvider, $httpProvider, $urlRouterProvider, $locationProvider, $compileProvider, $qProvider, $mdThemingProvider) {
  $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|data|mailto|tel|mystrength):/);
  // qProvider changed exception handling, this is necessary for tests to pass
  // link to change: https://github.com/angular/angular.js/commit/e13eeabd7e34a78becec06cfbe72c23f2dcb85f9
  // Can be fixed by reworking tests to handle rejections according to docs
  $qProvider.errorOnUnhandledRejections(false);
  // prevent IE11 from overly agressive caching
  // http://stackoverflow.com/questions/16098430/angular-ie-caching-issue-for-http
  $httpProvider.defaults.headers.get = $httpProvider.defaults.headers.get || {};
  $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
  $httpProvider.defaults.headers.get.Pragma = 'no-cache';
  // interceptor to add the session token to anything that requires auth
  $httpProvider.interceptors.push('authInterceptorSvc');
  // remove a trailing slash so it doesn't break our routing
  $urlRouterProvider.rule(function ($injector, $location) {
    var path = $location.path();
    if (path && path[path.length - 1] === '/') {
      return path.substr(0, path.length - 1);
    }
  });
  $urlRouterProvider.otherwise('/error/404');
  // dont use hash urls
  $locationProvider.html5Mode(true);

  var teladocPalette = $mdThemingProvider.extendPalette('deep-purple', {
    'A200': '#5B2F91'
  });

  $mdThemingProvider.definePalette('teladocPalette', teladocPalette);

  $mdThemingProvider.theme('default').accentPalette('teladocPalette');
}]).run(['$rootScope', '$state', 'msConfig', 'msAuth', 'windowSvc', '$log', 'languageSvc', '$timeout', 'NotifyingSvc', '$location', '$window', 'AxeWrapperSvc', function ($rootScope, $state, msConfig, msAuth, windowSvc, $log, languageSvc, $timeout, NotifyingSvc, $location, $window, AxeWrapperSvc) {
  var TIME_TO_OPEN_LOGOUT_MODAL = 3480000; // 58 minutes = 3 480 000 milliseconds
  // Set current year for use in footer copyright
  $rootScope.currentYear = new Date().getFullYear();
  // bind underscore to rootscope for use in templates
  $rootScope._ = _;
  // set the API version and production flag for debugging
  msConfig('version').then(function (version) {
    $rootScope.apiVersion = version;
  });
  msConfig('isProduction').then(function (isProduction) {
    $rootScope.isProduction = isProduction;
  });
  //we need to manually inject values from msConfig to msAuth a circular dependency chain ensues.
  msConfig('pingOneLogoutUrl').then(function (pingOneLogoutUrl) {
    return msAuth.setSsoLogoutUrl(pingOneLogoutUrl);
  });
  // Get sleepSection config from yml file
  msConfig('sleepSectionConfiguration').then(function (sleepSectionConfiguration) {
    $rootScope.sleepSectionConfiguration = sleepSectionConfiguration;
  });
  // Get gdprConfiguration config from yml file
  msConfig('gdprConfiguration').then(function (gdprConfiguration) {
    $rootScope.gdprConfiguration = gdprConfiguration;
  });

  msConfig('keyCloakConfiguration').then(function (keyCloakConfiguration) {
    $rootScope.keyCloakConfiguration = keyCloakConfiguration;
  });

  // WCAG parsing errors fix for generated material design tags in header
  var mdStyles = document.querySelectorAll('[md-theme-style]');
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = mdStyles[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var tag = _step.value;

      tag.removeAttribute('md-theme-style');
      tag.setAttribute('ng-attr-md-theme-style', '');
    }

    // check to see if they're trying to access an authed page without being logged in
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  $rootScope.$on('$stateChangeStart', function (event, toState, toParams) {
    if (!msAuth.isLoggedIn() && !(toState.data && toState.data.noAuth)) {
      //create a func to handle error states on re-auth failure
      var handleRedirect = function handleRedirect() {
        // user is not logged in and the route requires auth, send them to login
        var _redirect = $state.href(toState.name, toParams);
        $log.debug('stateChangeStart: User is not logged in - redirecting to login page with ' + _redirect);

        // Don't add redirect if is logout route
        if (windowSvc.isLogoutRoute()) {
          windowSvc.windowNavigate('/login');
        } else {
          windowSvc.windowNavigate('/login/?redirecturl=' + _redirect);
        }
      };
      //create a func to handle replaying the state nav on promise resolve
      var handleReplay = function handleReplay() {
        var params = angular.copy(toParams);
        $state.go(toState.name, params);
      };
      if (msAuth.hasReauthCookie()) {
        event.preventDefault();
        msAuth.reauth(moment.tz.guess()).then(handleReplay, handleRedirect);
      } else {
        handleRedirect();
      }
    }
  });

  if (msAuth.isLoggedIn() && msAuth.hasReauthCookie() && !isMobileWebView()) {
    $timeout.cancel($rootScope.reauthTimer);
    $rootScope.reauthTimer = $timeout(function () {
      NotifyingSvc.notifyEvent(NotifyingSvc.EVENTS.OPEN_MODAL, {
        templateUrl: 'core/templates/logout-modal.html',
        controller: 'LogoutModalCtrl',
        inputs: {}
      });
    }, TIME_TO_OPEN_LOGOUT_MODAL);
  }

  if (_.isFunction(languageSvc.setDefaultLanguage)) {
    languageSvc.setDefaultLanguage();
  }

  if ($window && $window.axe) {
    AxeWrapperSvc.init();
  }

  function isMobileWebView() {
    var queryParams = $location.search();
    var hasMobileJWT = msAuth.hasPermission('MOBILE');

    if (queryParams.isMobileWebView || hasMobileJWT) {
      return true;
    }
  }
}]);